import { createEffect, createEvent, createStore, forward, restore, } from "effector";
import { getAllTimetables } from "frontend/src/api/timetables";
export var pageMounted = createEvent();
export var pageUnmounted = createEvent();
var getTimetablesFx = createEffect(getAllTimetables);
export var $timetables = restore(getTimetablesFx, []);
export var $isPageLoaded = createStore(false);
export var $hasPageLoadingError = createStore(false);
export var $hasAnyTimetables = $timetables.map(function (timetables) { return timetables.length > 0; });
$isPageLoaded.on(getTimetablesFx.done, function () { return true; });
$hasPageLoadingError.on(getTimetablesFx.fail, function () { return true; }).reset(pageUnmounted);
forward({
    from: pageMounted,
    to: getTimetablesFx,
});
